import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, 
// CardActions,
CardMedia, CardContent, Typography, } from '@mui/material';
import { useConversationStore } from '../ConversationStoreProvider';
import Image from './Image';
import ItemTitle from './ItemTitle';
import { buildPortalAbsoluteHref, getPortalBasePath, resolvePortalItemRelativeUrl, toPortalRouterRelativePath, } from './portalNavigation';
const PortalItemCard = ({ title, image, description, url, width, openInNewTab, config = PortalItemCard.defaultProps.config, customStyle, onProductClick, onPortalRelativeNavigate, product, }) => {
    const cardConfig = config ?? PortalItemCard.defaultProps?.config;
    const conversationStore = useConversationStore();
    const imageUrl = image || product?.image || product?.screenshot || '';
    const handleClick = (e) => {
        e.preventDefault();
        const itemUrl = resolvePortalItemRelativeUrl({
            url: url ?? product?.url,
            type: product?.type,
            organizationID: product?.organizationID,
            id: product?.id,
            itemID: product?.itemID,
            slug: product?.slug,
        });
        // console.log('url', { url, itemUrl, product, onProductClick, onPortalRelativeNavigate });
        // Send tracking event
        conversationStore.currentConversation?.sendTrackingEvent('portal_item_click', {
            item_name: title,
            item_url: itemUrl,
        });
        if (onProductClick && product) {
            onProductClick(product);
            return;
        }
        if (!itemUrl.trim()) {
            return;
        }
        const rootPath = getPortalBasePath();
        console.log('itemUrl', { itemUrl, rootPath });
        const routerPath = toPortalRouterRelativePath(itemUrl, rootPath);
        if (openInNewTab) {
            const abs = buildPortalAbsoluteHref(rootPath, itemUrl);
            const w = window.open(abs, '_blank', 'noopener,noreferrer');
            if (w)
                w.opener = null;
            return;
        }
        if (onPortalRelativeNavigate && routerPath) {
            // console.log('doing nav relative', routerPath);
            onPortalRelativeNavigate(routerPath);
            return;
        }
        // console.log('doing full page load', itemUrl);
        window.location.assign(buildPortalAbsoluteHref(rootPath, itemUrl));
    };
    return (_jsx("div", { style: { textDecoration: 'none', color: 'inherit', cursor: 'pointer' }, onClick: handleClick, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick(e);
            }
        }, role: "button", tabIndex: 0, children: _jsxs(Card, { sx: {
                width,
                boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important',
                ...customStyle,
            }, children: [_jsx(CardMedia, { children: cardConfig.courseCardShowImage && (_jsx(Image, { url: imageUrl, status: "loaded", alt: title, customStyle: { width: '100%', height: '200px', objectFit: 'cover' }, 
                        // blank image
                        fallbackSrc: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" })) }), _jsxs(CardContent, { sx: {
                        p: 1,
                        '&:last-child': {
                            pb: 1,
                        },
                    }, children: [cardConfig.courseCardShowTitle && (_jsx(ItemTitle, { title: title })), cardConfig.courseCardShowDesc && (_jsx(Typography, { component: "div", variant: "body1", className: "description", sx: {
                                display: '-webkit-box',
                                WebkitLineClamp: cardConfig.courseCardMaxLinesDescription,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                maxHeight: `${cardConfig.courseCardMaxLinesDescription * 1.5}em`,
                            }, children: description }))] })] }) }));
};
PortalItemCard.defaultProps = {
    onPortalRelativeNavigate: undefined,
    config: {
        courseCardShowImage: true,
        courseCardShowTitle: true,
        courseCardShowInstructor: false,
        courseCardShowPrice: false,
        courseCardShowButton: false,
        courseCardMaxLinesDescription: 4,
    },
    customStyle: undefined,
    onProductClick: undefined,
    product: undefined,
};
export default PortalItemCard;
//# sourceMappingURL=PortalItemCard.js.map